<script lang="ts">
  type ProductBadgeProps = {
    variationId: string;
  };

  let { variationId }: ProductBadgeProps = $props();
</script>

<ft9-productbadge-v1
  feature="recoSpaProductCampaignFlag"
  team="hopper"
  variation-id={variationId}
  personalized-reco
  class="product-badge"
>
</ft9-productbadge-v1>

<style lang="scss">
  .product-badge {
    position: absolute;
    left: 12px;
    top: 12px;
    width: 50px;
    height: 50px;
    z-index: 1;
  }
</style>
